module.exports = __webpack_public_path__ + "img/eye.4fa0bbc1.png";